export const SET = "USER_SET";

export default {
  SET
};
